<template>
    <div id="app">
        <VueNotification />
        <div class="loading_init" v-if="isLoading"><div></div></div>
        <transition name="fade">
            <router-view v-if="!isLoading" :class="{'modal-open' : modalOpened}"></router-view>
        </transition>
        <transition name="modal">
            <div class="modal-mask" v-if="modalOpened" @click.self="closeModal()">
                <router-view v-if="!isLoading" name="modal"></router-view>
            </div>
        </transition>
    </div>
</template>

<script>
    import bus from '@/utils/events/bus.js'
    import moment from 'moment-timezone'
    import Zendesk from '@/assets/vendor/zendesk'
    import Sentry from '@/assets/vendor/sentry'
    import { mapActions, mapGetters } from 'vuex'
    import { isEmpty } from 'lodash'
    import VueNotification from '@/components/helpers/VueNotifications'

    export default {
        name: 'PumpMyLead',
        components: { VueNotification },
        data () {
            return {
                isLoading: false
            }
        },
        metaInfo: {
            title: 'Pump My Lead'
        },
        created () {
            this.isLoading = true
            this.fetchData()
            Sentry.init()
            Zendesk.init()
        },
        mounted () {
            this.setMaProps()
        },
        computed: {
            ...mapGetters({
                member: 'getMember',
                company: 'getCompany',
                token: 'getToken'
            }),
            modalOpened () {
                return this.$route.matched.length && typeof this.$route.matched[0].components['modal'] !== 'undefined'
            }
        },
        watch: {
            member (val) {
                Zendesk.setMember(val)
                Sentry.setMember(val)
                this.setMaProps()
            }
        },
        methods: {
            ...mapActions([ 'initStore' ]),
            closeModal () {
                bus.$emit('goBack')
            },
            fetchData () {
                const hasTokenStored = () => !isEmpty(window.localStorage.getItem('pml_token'))

                const hasUtcOffsetStored = () => !isEmpty(window.localStorage.getItem('utcOffset'))

                if (hasTokenStored() && (isEmpty(this.token) || isEmpty(this.member)))
                    this.initStore()
                        .then(() => { this.isLoading = false })
                else
                    setTimeout(() => { this.isLoading = false }, 500)

                if (!hasUtcOffsetStored() || moment(window.localStorage.getItem('utcOffset'), 'HH:mm').toDate().toString() !== 'Invalid Date')
                    window.localStorage.setItem('utcOffset', moment.tz.guess())
            },
            setMaProps () {
                if (this.member.id && typeof this.$ma !== 'undefined') {
                    this.$ma.identify({
                        userId: this.member.id,
                        options: { newUser: true }
                    })
                    this.$ma.setUserProperties({
                        userId: this.member.id,
                        name: this.member.full_name,
                        email: this.member.email
                    })
                }

                if (this.company.id && typeof this.$ma !== 'undefined')
                    this.$ma.setSuperProperties({
                        userId: this.company.id,
                        name: this.company.fancy_name,
                        email: this.company.email
                    })
            }
        }
    }
</script>

<style src="assets/sass/app.scss" lang="sass"></style>



// WEBPACK FOOTER //
// src/App.vue